/** Notes for presenting Step Four inventories to a sponsor (Step 5 Action 3). */
export interface Step5InventoryPresentationRecord {
  /** Date of the first presentation session (additional meetings may follow) */
  startedDate?: string;
  /** Where you meet — in-person location(s) or online */
  place?: string;
  /** How presenting went and how you feel */
  reflection?: string;
  updatedAt?: string;
}

export const EMPTY_STEP5_INVENTORY_PRESENTATION: Step5InventoryPresentationRecord = {};

export function normalizeStep5InventoryPresentation(
  raw: unknown
): Step5InventoryPresentationRecord {
  if (!raw || typeof raw !== 'object') return { ...EMPTY_STEP5_INVENTORY_PRESENTATION };
  const o = raw as Record<string, unknown>;
  const trim = (v: unknown) => (typeof v === 'string' ? v.trim() : '');

  const startedDate = trim(o.startedDate);
  const place = trim(o.place);
  const reflection = trim(o.reflection);
  const updatedAt = typeof o.updatedAt === 'string' ? o.updatedAt : undefined;

  const hasContent = !!(startedDate || place || reflection);
  if (!hasContent) return {};

  return {
    ...(startedDate ? { startedDate } : {}),
    ...(place ? { place } : {}),
    ...(reflection ? { reflection } : {}),
    ...(updatedAt ? { updatedAt } : {}),
  };
}
